import React from 'react';
import _ from 'lodash';

const OptionsHelper = (options) => {
    if (_.isEmpty(options)) { return []; }
    
    let items = [];

    if (!_.isEmpty(options.list)) {
        const keyField = !_.isEmpty(options.keyField) ? options.keyField : 'id';
        const nameField = !_.isEmpty(options.nameField) ? options.nameField : 'name';
        const disabledField = !_.isEmpty(options.disabledField) ? options.disabledField : 'disabled';

        items = options.list.map((item) => {
            const selected = (options.selectedValue === item[keyField]) ? { selected: true } : null;
            const disabled = (item[disabledField] === true) ? { disabled: true } : null;
            return <option key={item[keyField]} value={item[keyField]} {...selected} {...disabled}>{item[nameField]}</option>;
        });
    }

    if (!_.isEmpty(options.defaultOptions)) {
        const values = options.defaultOptions.reverse();

        for(let i = 0; i < values.length; i++) {
            const selected = (!_.isEmpty(options.selectedValue) && options.selectedValue === values[i][1]) ? { selected: true } : null;

            items.unshift(<option key={values[i][0]} value={values[i][0]} {...selected}>{values[i][1]}</option>);
        }
    }

    if (options.includeBlank && options.includeBlankName) {
        items.unshift(<option key='unselected' value=''>{options.includeBlankName}</option>);
    } else if (options.includeBlank){
        items.unshift(<option key='unselected' value=''></option>);
    }
    
    return items;
};

export default OptionsHelper;
